import React from "react";
import { useNavigate } from "react-router-dom";
import "./TaskInfoPage.css";
import search from "../../../assets/search.png";
import FakeNavigation from "../../../components/FakeNav/FakeNav";

const TaskInfoPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div role="main" className="wrapper">
      <div className="title"></div>
      <div className="title22">
        <div>Решение ситуационных задач - 3-й этап (Мультикейсы)</div>
        <div className="imgCont">
          <img src={search} alt="" style={{ width: 20 }} />
        </div>
      </div>
      <div className="container">
        <div className="content">
          <div
            onClick={() => {
              localStorage.clear();

              navigate("/");
            }}
            className="gohome"
          >
            Выход
          </div>
          <div></div>
          <div className="">
            <table className="generaltable quizattemptsummary">
              <thead>
                <tr>
                  <th
                    className="sit_title"
                    style={{
                      gap: 10,
                      borderLeft: "2px solid #ff4c5b",
                    }}
                    scope="col"
                    onClick={() => {
                      navigate("/start-task");
                    }}
                  >
                    <div
                      style={{
                        borderRadius: 50,
                        backgroundColor: "#ff4c5b",
                        width: 20,
                        height: 20,
                      }}
                    ></div>
                    Ситуационная задача
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <table className="generaltable quizattemptsummary">
            <thead>
              <tr>
                <th
                  className="header c0"
                  style={{
                    textAlign: "start",
                    color: "gray",
                    fontSize: "24px",
                  }}
                  scope="col"
                >
                  Тема 1
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <FakeNavigation />
      </div>
    </div>
  );
};

export default TaskInfoPage;
